import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { http, todayISO, addDays, errMsg } from "@/lib/api";

export default function BulkEditDialog({ open, onOpenChange, rooms, propertyId, onSaved }) {
  const [f, setF] = useState({ room_type_id: "", date_from: todayISO(), date_to: addDays(todayISO(), 30), price: "", allotment: "", closed: "keep" });
  useEffect(() => { if (open && !f.room_type_id && rooms[0]) setF((o) => ({ ...o, room_type_id: rooms[0].id })); }, [open, rooms]); // eslint-disable-line
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    const u = { room_type_id: f.room_type_id, date_from: f.date_from, date_to: f.date_to };
    if (f.price !== "") u.price = Number(f.price);
    if (f.allotment !== "") u.allotment = Number(f.allotment);
    if (f.closed !== "keep") u.closed = f.closed === "close";
    try {
      const { data } = await http.put(`/extranet/properties/${propertyId}/calendar`, { updates: [u] });
      toast.success(`${data.applied} hari diperbarui`);
      onOpenChange(false); onSaved();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="extranet" data-testid="bulk-edit-dialog">
        <DialogHeader><DialogTitle>Edit massal tarif & ketersediaan</DialogTitle></DialogHeader>
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="sm:col-span-2"><Label>Tipe kamar</Label>
            <Select value={f.room_type_id} onValueChange={(v) => setF({ ...f, room_type_id: v })}>
              <SelectTrigger data-testid="bulk-room-select" className="mt-1.5"><SelectValue /></SelectTrigger>
              <SelectContent>{rooms.map((r) => <SelectItem key={r.id} value={r.id}>{r.name}</SelectItem>)}</SelectContent>
            </Select></div>
          <div><Label>Dari tanggal</Label><Input data-testid="bulk-from" type="date" value={f.date_from} onChange={set("date_from")} className="mt-1.5" /></div>
          <div><Label>Sampai tanggal</Label><Input data-testid="bulk-to" type="date" value={f.date_to} onChange={set("date_to")} className="mt-1.5" /></div>
          <div><Label>Harga baru (Rp)</Label><Input data-testid="bulk-price" type="number" placeholder="Biarkan kosong" value={f.price} onChange={set("price")} className="mt-1.5" /></div>
          <div><Label>Kamar dijual</Label><Input data-testid="bulk-allotment" type="number" placeholder="Biarkan kosong" value={f.allotment} onChange={set("allotment")} className="mt-1.5" /></div>
          <div className="sm:col-span-2"><Label>Status</Label>
            <Select value={f.closed} onValueChange={(v) => setF({ ...f, closed: v })}>
              <SelectTrigger data-testid="bulk-status-select" className="mt-1.5"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="keep">Jangan ubah</SelectItem><SelectItem value="open">Buka</SelectItem><SelectItem value="close">Tutup</SelectItem></SelectContent>
            </Select></div>
        </div>
        <DialogFooter>
          <button data-testid="bulk-save-button" onClick={save} className="rounded-md bg-[#006CE4] px-5 py-2 font-semibold text-white hover:bg-[#0052B4]">Terapkan</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
